import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { SteeringPath } from '@splixer/player';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faPlay } from '@fortawesome/sharp-regular-svg-icons/faPlay';
import { faSquareUp } from '@fortawesome/pro-light-svg-icons';

@Component({
  selector: 'steering-wheel-button',
  templateUrl: 'steering-wheel-button.component.html',
  standalone: true,
  imports: [
    FaIconComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SteeringWheelButtonComponent {
  public readonly item = input.required<SteeringPath>();
  public readonly buttonTitle = input<string | undefined>(undefined);
  public playPath = output<SteeringPath>();
  public queuePath = output<SteeringPath>();

  protected readonly faAdd = faSquareUp;
  protected readonly faPlay = faPlay;

  protected pathDescriptionClickedEvent = () => {
    this.playPath.emit(this.item());
  };

  protected addToQueueEvent = () => {
    this.queuePath.emit(this.item());
  };

  protected playNowEvent = () => {
    this.playPath.emit(this.item());
  }
}
